import { memo, useCallback } from 'react';

import { TypographyWithTooltip } from '@lyearn/molecules';
import { Stack, Tooltip, Typography } from '@lyearn/ui';

import { ICON_CONFIG } from './const';
import { MGSAEntityTypes } from './type';

interface MGSAEntityProps {
  className?: string;
  entities?: any[]; // TODO: {id:string,name:string}[] aryan
  title?: string;
  type: MGSAEntityTypes;
}

const MGSAEntity: React.FC<MGSAEntityProps> = ({ entities, className, title, type }) => {
  const extra = Math.max(0, (entities?.length ?? 0) - 2);
  const Icon = ICON_CONFIG[type];
  const renderer = useCallback(() => {
    if (!extra || !entities?.length) return null;
    const entitiesToShow = entities.slice(2);
    return (
      <Stack className="overflow-hideen">
        <Stack className="w-full h-full max-h-[20rem] p-4 overflow-y-auto" direction="col" gap={8}>
          {entitiesToShow.map((entity, index) => (
            <Stack key={index} alignItems="center" className="" gapX={8}>
              <Icon className="w-18 h-18" fillColorToken="icon-placeholder" />
              <Typography
                className="text-text-tertiary max-w-[20rem] truncate"
                variant="body-short-02">
                {entity?.name}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    );
  }, [extra, entities, Icon]);
  if (!entities?.length) {
    return null;
  }
  const entitiesToShow = entities.slice(0, 2);

  return (
    <Stack className={className} direction="col">
      <Typography as="h2" className="ms-4" variant="heading-xs">
        {title}
      </Typography>
      <Stack className="mt-24 flex-wrap" gap={16}>
        {entitiesToShow.map((entity, index) => (
          <Stack
            key={index}
            alignItems="center"
            className="min-w-0 px-12 py-8 select-none rounded-8 border border-border bg-bg-secondary"
            gapX={8}>
            <Icon className="w-18 h-18 shrink-0" fillColorToken="icon-secondary" />
            <TypographyWithTooltip
              className="bg-secondary min-w-0"
              numberOfLines={1}
              variant="body-short-03">
              {entity?.name}
            </TypographyWithTooltip>
          </Stack>
        ))}
        {extra ? (
          <Tooltip
            classes={{
              popper: 'z-50',
              tooltip: 'border-0 rounded-8',
              arrow: '',
            }}
            placement="bottom"
            title={renderer()}>
            <Stack
              className="px-12 py-8 select-none rounded-8 border border-border bg-bg-secondary"
              gapX={8}>
              <Typography className="text-text-paragraph" variant="body-short-03">
                +{extra}
              </Typography>
            </Stack>
          </Tooltip>
        ) : null}
      </Stack>
    </Stack>
  );
};

export default memo(MGSAEntity);
